import clsx from "clsx";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import {
  currencySignSelector,
  formatPrice,
  NO_VALUE_DISPLAY,
} from "@ryde/shared";

import { IRideSoftValidationErrorItemProps } from "../models";

export const RideSoftValidationErrorPriceRateChangedRideCancel: FC<
  IRideSoftValidationErrorItemProps
> = ({ error }) => {
  const currencySign = useRecoilValue(currencySignSelector);
  const { t } = useTranslation();

  const message = `${t("ride.RIDE_SOFT_VALIDATION_ERROR_PRICE_CHANGED")}`;
  const willBe = `${t("ride.RIDE_SOFT_VALIDATION_WILL_BE")}`;
  const was = `${t("ride.RIDE_SOFT_VALIDATION_WAS")}`;
  const isLost = Number(error.additional?.savedPrice) < 0;
  const savedLost = !isLost
    ? t("ride.RIDE_SOFT_VALIDATION_SAVED")
    : t("ride.RIDE_SOFT_VALIDATION_DIFFERENCE");
  const minusResolved = isLost ? "-" : "";
  const savedPriceResolved = Number(error.additional?.savedPrice ?? 0);

  return (
    <li>
      {message} (<b>{willBe}:</b> {currencySign}
      {String(error.additional?.newPrice ?? NO_VALUE_DISPLAY)} | <b>{was}: </b>
      {currencySign}
      {formatPrice({
        value: Number(error.additional?.oldBothRidePrice ?? 0),
      })}{" "}
      |{" "}
      <span
        className={clsx({
          saved: !isLost,
          lost: isLost,
        })}
      >
        {savedLost}: {currencySign}
        <span dir="ltr">
          {minusResolved}
          {formatPrice({
            value: isLost ? -1 * savedPriceResolved : savedPriceResolved,
          })}
        </span>
      </span>
      )
    </li>
  );
};
